// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"form-select_wrapper__SnVDs","label":"form-select_label__K4d9l","arrow":"form-select_arrow__SkI0V","select":"form-select_select__SFANO"};